var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingAnimation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Main-Scene",
    viewBox: "0 0 400 225 ",
    width: 130,
    height: 130,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes a0_do { 0% { stroke-dashoffset: 0px; } 100% { stroke-dashoffset: 1100.9px; } }\n    @keyframes a1_mo { 0% { offset-distance: 0%; animation-timing-function: cubic-bezier(.3,0,.7,1);\n    } 16.7% { offset-distance: 16.698%; animation-timing-function: cubic-bezier(.3,0,.7,1); } 33.3%\n    { offset-distance: 33.396%; animation-timing-function: cubic-bezier(.3,0,.7,1); } 50% {\n    offset-distance: 50.094%; animation-timing-function: cubic-bezier(.3,0,.7,1); } 66.7% {\n    offset-distance: 66.793%; animation-timing-function: cubic-bezier(.3,0,.7,1); } 83.3% {\n    offset-distance: 83.491%; animation-timing-function: cubic-bezier(.3,0,.7,.8); } 100% {\n    offset-distance: 100%; } }\n    @keyframes a2_t { 0% { transform: translate(92.8px,171.8px) rotate(0deg) translate(-25px,-25px);\n    } 100% { transform: translate(92.8px,171.8px) rotate(709deg) translate(-25px,-25px); } }\n    @keyframes a3_t { 0% { transform: translate(302.8px,171.8px) rotate(0deg)\n    translate(-25px,-25px); } 100% { transform: translate(302.8px,171.8px) rotate(709deg)\n    translate(-25px,-25px); } }\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(198,108.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#58595b",
    d: "M-153.5 87c0 0 311 0 311 0",
    stroke: "#242e44",
    strokeOpacity: 0.63,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "289.2 21.8",
    style: {
      animation: "1s linear infinite both a0_do"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translate(-171px,-66.5px)",
      animation: "1s linear infinite both a1_mo",
      offsetPath: "path('M200,112C200,112.667,200,116,200,116C200,116,200,112,200,112C200,112,200,116,200,116C200,116,200,112,200,112C200,112,200,116,200,116C200,116,200,112.806,200,112.045')",
      offsetRotate: "0deg"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,20.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(177.7,82.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23211e",
    d: "M120.2-23.1c0 0 23.5 18.5 23.5 18.5c0 0-2.8 18.9-2.8 18.9c0 0-10.1 11.2-10.1 11.2c0 0-62.7 1.2-62.7 1.2c0 0-152.8 1.7-152.8 1.7c0 0-52-9.2-52-9.2c0 0-6.9-1.8-6.9-1.8c0 0 13.8-33.9 13.8-33.9c0 0 44.6-11.9 44.6-11.9c0 0 205.4 5.3 205.4 5.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218.4,34)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#404041",
    d: "M-26-19.5c0 0 30.3 10.4 54.6 23c0 0 8 6.1 5.9 10.5c0 0-7.6 5.5-7.6 5.5c0 0-63.5-33.3-63.5-33.3c0 0 5.8-4.2 5.8-4.2c0 0 4.8-1.5 4.8-1.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.6,33.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#404041",
    d: "M25.5-15.6c0 0-34.9 13.1-43.1 19c0 0-7.9 2.5-7.9 2.5c0 0-1.4 4.6-1.4 4.6c0 0 7 5.1 7 5.1c0 0 46.8-26.7 46.8-26.7c0 0-1.4-4.5-1.4-4.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.5,56.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e6e7e8",
    d: "M167.8 28c2.5-7.3-0.2-12.7-2.7-18.6c-3.8-8.8-72.7-25.5-89.9-28.7c0 0 7 3.4 .4 9.6c0 0-45.9-24.5-57-29c0 0 3.5-3.4 3.5-3.4c0 0-43.6-13.8-114.3 4.1c0 0 0 2.1 0 2.1c0 0-43.9 22.8-43.9 22.8c0 0-9.4-1.4 .6-5.9c-19.2 6.2-25.7 6.6-26.8 10c0 0 .3 18.7 .3 18.7c0 0 0 5.5 0 5.5c0 0-8.3 3.1-7.2 9c1 5.8 2.7 11 2.7 11c0 0 1.7 1.1 1.7 1.1c0 0 .7 7.2 .7 7.2c0 0 17.4 9.7 31.3 10.8c-3.8-17.5 2.6-34.8 28.7-34c22.5 .7 26.7 23.9 26.7 23.9c0 0 .3 9.7 .3 9.7c0 0 .4 2 .4 2c0 0 150.9-2.7 150.9-2.7c0 0 0-6.6 0-6.6c0 0 0-2.1 0-2.1c0 0 .2-23.2 31.6-24.9c31.4-1.7 30.6 30.4 30.6 30.4c0 0 .7 4.8 .7 4.8c0 0 24.1-0.3 28.7-9.7c0 0 .3-13 2-17.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(285.9,85.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d2d3",
    d: "M-48.8 23.7c0 0 7.7-0.1 7.7-0.1c0 0 0-6.6 0-6.6c0 0 0-2.1 0-2.1c0 0 .1-23.2 31.6-24.9c31.4-1.7 30.6 30.4 30.6 30.4c0 0 .7 4.8 .7 4.8c0 0 24.1-0.3 28.6-9.7c0 0 .1-3.6 .4-7.6c0 0-20.5 3-20.5 3c0 0-3.2-9.7-13-18.8c-18.7-17.3-49.1-12.6-63 10.1c-3.6 5.9-5.1 16.8-5.1 16.8c0 0 .6 1.9 2 4.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.5,85.9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d2d3",
    d: "M-43-14.6c0 0-8.3 3.1-7.3 9c1.1 5.9 2.8 11.1 2.8 11.1c0 0 1.7 1 1.7 1c0 0 .7 7.3 .7 7.3c0 0 17.4 9.7 31.2 10.7c-2.5-16.5 2.7-34.8 28.8-34c22.4 .7 26.7 23.9 26.7 23.9c0 0 .2 6.1 .2 6.1c5.8-2.1 9.5-3.5 9.5-3.5c-5.6-22.2-21.4-41.5-46.8-34.7c-11.8 3.2-18.9 13.3-18.9 13.3c0 0-7.5-0.9-14.4-3.5c-6.9-2.6-14.2-6.7-14.2-6.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.2,106.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d0d2d3",
    d: "M76-5.4c0 0-0.7 8-0.7 8c0 0-150.3 3-150.3 3c0 0-0.5-2-0.5-2c0 0-0.5-9-0.5-9c0 0 3.9-0.2 3.9-0.2c0 0 4.9 2 4.9 2c0 0 134.4-0.2 134.4-0.2c0 0 1.4-1.8 1.4-1.8c0 0 7.4 .2 7.4 .2Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(327.4,90.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7c9ce",
    d: "M11.2-7.2c0 0-1.9 10.5-1.9 10.5c0 0-18.5 3.9-20.5 2.9c0 0 1.5-8.9 1.5-8.9c0 0 18.6-1.2 20.9-4.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.3,65.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fbf9f6",
    d: "M13.5 .3c0 0-2.1-3.5-4.5-5c0 0-3.1-0.2-8.5 1.2c-5.3 1.3-9 1.9-9 1.9c0 0-5.7 1.3 2.6 3.9c8.3 2.6 13.8 2.4 17 .9c3.1-1.6 2.4-2.9 2.4-2.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.8,34.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#404041",
    d: "M-14.5-17.8c-32.5 1.6-44 7.8-51.6 11.5c0 0-11.5 7.4-14.5 10.1c0 0-9.4 9.2-0.9 9.2c4.9 0 37.1 .9 63.8 1.7c0 0 9.4-32.7 9.4-32.7c-2 0-4 .1-6.2 .2Zm104.5 35.9c0 0-71.1-2.3-71.1-2.3c0 0-13.7-0.4-31-0.9c5-19 4.1-16.2 9.7-33c23.9 .1 34.4 4.2 34.4 4.2c21.6 6.4 58 32 58 32Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164.8,60.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58595b",
    d: "M-8.7 0c0 .8 3.9 1.5 8.7 1.5c4.8 0 8.7-0.7 8.7-1.5c0-0.8-3.9-1.5-8.7-1.5c-4.8 0-8.7 .7-8.7 1.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.3,56.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58595b",
    d: "M-8.7 0c0 .8 3.9 1.5 8.7 1.5c4.8 0 8.7-0.7 8.7-1.5c0-0.8-3.9-1.5-8.7-1.5c-4.8 0-8.7 .7-8.7 1.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.5,60.6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c21212",
    d: "M-12.5-6.5c0 0 3.3 17.3 3.3 17.3c0 0 21.7-4.3 21.7-4.3c0 0-3.3-17.3-3.3-17.3c0 0-21.7 4.3-21.7 4.3Zm4.3-0.5c-1.7 4.3 .3 12.4 .3 12.4c2.1 .5 10.6 1.6 13.1 0c3.5-2.3 4.7-10.1 .2-11.4c-3.4-0.9-9.4-1-12.1-1c-0.9 0-1.5 0-1.5 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.7,49.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ced0d1",
    d: "M-8.5 5.7c3.1 .9 15.6 .1 16.3-2.6c.8-2.7-10.1-9.7-16.4-9.1c0 0 .1 11.7 .1 11.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336.8,73.7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M-3-8.6c0 0 0 17.2 0 17.2c0 0 6 0 6 0c0 0 0-17.2 0-17.2c0 0-6 0-6 0Zm.1 3.2c-0.1 4.3 .9 13.9 2.4 13.9c1.6 .1 2.8-0.9 2.8-1.3c.7-10.7-3.6-15.6-3.6-15.6c0 0-0.2-0.2-0.5-0.2c-0.5 0-1 .6-1.1 3.2Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.8,171.8) translate(-25,-25)",
    style: {
      animation: "1s linear infinite both a2_t"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25,25) scale(.88,.88) translate(-30,-30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.8,30.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58595b",
    d: "M.1-20.6c-11.3 0-20.6 9.1-20.7 20.5c0 11.4 9.1 20.6 20.5 20.7c11.3 0 20.6-9.1 20.7-20.5c0-11.3-9.1-20.6-20.5-20.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-18.4c0 0-4.5 14.1-4.5 14.1c0 0-14.8 0-14.8 0c0 0 12 8.6 12 8.6c0 0-4.6 14.1-4.6 14.1c0 0 11.9-8.7 11.9-8.7c0 0 11.9 8.7 11.9 8.7c0 0-4.6-14.1-4.6-14.1c0 0 12-8.6 12-8.6c0 0-14.8 0-14.8 0c0 0-4.5-14.1-4.5-14.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363638",
    d: "M-13.9-14c7.8-7.7 20.2-7.6 27.9 .1c7.7 7.8 7.6 20.2-0.1 27.9c-7.8 7.7-20.2 7.6-27.9-0.1c-7.7-7.8-7.6-20.2 .1-27.9Zm32.9 33.2c10.6-10.5 10.7-27.6 .2-38.2c-10.5-10.6-27.6-10.7-38.2-0.2c-10.6 10.5-10.7 27.6-0.2 38.2c10.5 10.6 27.6 10.7 38.2 .2Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9da0a5",
    d: "M0-5.3c3 0 5.3 2.4 5.3 5.3c0 3-2.4 5.3-5.3 5.3c-3 0-5.3-2.4-5.3-5.3c0-3 2.4-5.3 5.3-5.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.6 0c0-11.9-9.7-21.6-21.6-21.6c-11.9 0-21.6 9.7-21.6 21.6c0 11.9 9.7 21.6 21.6 21.6c11.9 0 21.6-9.7 21.6-21.6Zm-7.6-13.9c7.7 7.8 7.6 20.2-0.1 27.9c-7.8 7.7-20.2 7.6-27.9-0.1c-7.7-7.8-7.6-20.2 .1-27.9c7.8-7.7 20.2-7.6 27.9 .1Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.8,16.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.2-7.1c.1-0.5 2.6 14.7 2.6 14.7c0 0-9.6 0-9.6 0c0 0 2.6-14.3 2.6-14.7c-0.1-0.5 4.4 0 4.4 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.4,27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5-1.1c.6-0.1-12.8 6.5-12.8 6.5c0 0-2.8-8.8-2.8-8.8c0 0 14-1.7 14.4-1.9c.4-0.1 1.2 4.2 1.2 4.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.6,40.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 7.6c.3 .4-9.9-10.5-9.9-10.5c0 0 7.6-5.1 7.6-5.1c0 0 5.7 12.9 6 13.2c.2 .3-3.7 2.4-3.7 2.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.9,40.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-7 5.1c-0.4 .4 6.8-13.3 6.8-13.3c0 0 7.6 5.7 7.6 5.7c0 0-10.6 9.9-10.9 10.3c-0.2 .4-3.5-2.7-3.5-2.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.4,27.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-6.3-5.4c-0.5-0.2 14.5 2.1 14.5 2.1c0 0-3 8.9-3 8.9c0 0-12.5-6.8-13-6.9c-0.4 0 1.5-4.1 1.5-4.1Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.8,171.8) translate(-25,-25)",
    style: {
      animation: "1s linear infinite both a3_t"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25,25) scale(.88,.88) translate(-30,-30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.8,30.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#58595b",
    d: "M.1-20.6c-11.3 0-20.6 9.1-20.7 20.5c0 11.4 9.1 20.6 20.5 20.7c11.3 0 20.6-9.1 20.7-20.5c0-11.3-9.1-20.6-20.5-20.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,28)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-18.4c0 0-4.5 14.1-4.5 14.1c0 0-14.8 0-14.8 0c0 0 12 8.6 12 8.6c0 0-4.6 14.1-4.6 14.1c0 0 11.9-8.7 11.9-8.7c0 0 11.9 8.7 11.9 8.7c0 0-4.6-14.1-4.6-14.1c0 0 12-8.6 12-8.6c0 0-14.8 0-14.8 0c0 0-4.5-14.1-4.5-14.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#363638",
    d: "M-13.9-14c7.8-7.7 20.2-7.6 27.9 .1c7.7 7.8 7.6 20.2-0.1 27.9c-7.8 7.7-20.2 7.6-27.9-0.1c-7.7-7.8-7.6-20.2 .1-27.9Zm32.9 33.2c10.6-10.5 10.7-27.6 .2-38.2c-10.5-10.6-27.6-10.7-38.2-0.2c-10.6 10.5-10.7 27.6-0.2 38.2c10.5 10.6 27.6 10.7 38.2 .2Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9da0a5",
    d: "M0-5.3c3 0 5.3 2.4 5.3 5.3c0 3-2.4 5.3-5.3 5.3c-3 0-5.3-2.4-5.3-5.3c0-3 2.4-5.3 5.3-5.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,30)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.6 0c0-11.9-9.7-21.6-21.6-21.6c-11.9 0-21.6 9.7-21.6 21.6c0 11.9 9.7 21.6 21.6 21.6c11.9 0 21.6-9.7 21.6-21.6Zm-7.6-13.9c7.7 7.8 7.6 20.2-0.1 27.9c-7.8 7.7-20.2 7.6-27.9-0.1c-7.7-7.8-7.6-20.2 .1-27.9c7.8-7.7 20.2-7.6 27.9 .1Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.8,16.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.2-7.1c.1-0.5 2.6 14.7 2.6 14.7c0 0-9.6 0-9.6 0c0 0 2.6-14.3 2.6-14.7c-0.1-0.5 4.4 0 4.4 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.4,27)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5-1.1c.6-0.1-12.8 6.5-12.8 6.5c0 0-2.8-8.8-2.8-8.8c0 0 14-1.7 14.4-1.9c.4-0.1 1.2 4.2 1.2 4.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.6,40.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 7.6c.3 .4-9.9-10.5-9.9-10.5c0 0 7.6-5.1 7.6-5.1c0 0 5.7 12.9 6 13.2c.2 .3-3.7 2.4-3.7 2.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.9,40.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-7 5.1c-0.4 .4 6.8-13.3 6.8-13.3c0 0 7.6 5.7 7.6 5.7c0 0-10.6 9.9-10.9 10.3c-0.2 .4-3.5-2.7-3.5-2.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.4,27.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-6.3-5.4c-0.5-0.2 14.5 2.1 14.5 2.1c0 0-3 8.9-3 8.9c0 0-12.5-6.8-13-6.9c-0.4 0 1.5-4.1 1.5-4.1Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingAnimation);
export default __webpack_public_path__ + "static/media/loading-animation.eb4830050fa8e7ba9379fb16938c6d68.svg";
export { ForwardRef as ReactComponent };